import React, { useEffect, useState } from 'react';

import Select from "react-select";
import { City } from "country-state-city";

const SidebarDDLocation = ({ selectedCities, setSelectedCities, cityOptions, icon }) => {
    return (
        <div className="w-full cursor-pointer">
            <Select
                isMulti
                options={cityOptions}
                value={selectedCities}
                onChange={(selected) => setSelectedCities(selected)}
                placeholder="Select cities..."
                className="text-sm w-full"
                classNamePrefix="select"
                isSearchable
                closeMenuOnSelect={false}
                styles={{
                    control: (base) => ({
                        ...base,
                        cursor: "pointer",
                    }),
                    option: (base, state) => ({
                        ...base,
                        cursor: "pointer",
                    }),
                }}
            />
        </div>
    );
};

export default SidebarDDLocation;
